var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [_vm._v("Loading…")]
          ),
        ])
      : !_vm.rows.length
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [_vm._v("No admissions data found.")]
          ),
        ])
      : _c("div", { staticClass: "box" }, [
          _c("div", { staticClass: "box-content" }, [
            _c("table", { staticClass: "shx-table w-100 mt-2" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.rows, function (row) {
                  return _c("tr", { key: row.year }, [
                    _c(
                      "td",
                      [
                        _c(
                          "router-link",
                          { attrs: { to: "/admissions/year/" + row.year } },
                          [_vm._v(_vm._s(row.year))]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(_vm.formatInt(row.admissions))),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(_vm.formatInt(row.admissions_bf))),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(row.weeks)),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(row.cinemas)),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(row.titles)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "btn btn-sm btn-outline-secondary",
                            attrs: { to: "/admissions/year/" + row.year },
                          },
                          [
                            _vm._v(
                              "\n                                Per Week\n                            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("tfoot", [
                _c("tr", [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.formatInt(_vm.totalAdmissions))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.formatInt(_vm.totalAdmissionsBf))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { attrs: { colspan: "4" } }),
                ]),
              ]),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "box view-nav-bar" }, [
      _c("div", { staticClass: "d-flex align-items-center w-100" }, [
        _c("span", { staticClass: "text-muted" }, [
          _vm._v("Admissions per year — all saleshouses vs "),
          _c("strong", [_vm._v("BF")]),
          _vm._v(" only"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "shx-th-100" }, [_vm._v("Year")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Admissions (all)")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Admissions (BF)")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [_vm._v("# Weeks")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("# Cinemas"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("# Titles"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-120" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [_c("strong", [_vm._v("Total")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }